import { render, staticRenderFns } from "./EstablishProduct.vue?vue&type=template&id=70464e35&scoped=true"
import script from "./EstablishProduct.vue?vue&type=script&lang=js"
export * from "./EstablishProduct.vue?vue&type=script&lang=js"
import style0 from "./EstablishProduct.vue?vue&type=style&index=0&id=70464e35&prod&lang=scss&scoped=true"
import style1 from "./EstablishProduct.vue?vue&type=style&index=1&id=70464e35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70464e35",
  null
  
)

export default component.exports